var map = {
	"./gal-1.jpg": "9fad",
	"./gal-2.jpg": "cc23",
	"./gal-3.jpg": "a2ef",
	"./gal-4.jpg": "1bf4",
	"./gal-5.jpg": "1e76",
	"./gal-6.jpg": "c986",
	"./gal-7.jpg": "e373",
	"./gal-8.jpg": "f5f4",
	"./gal-9.jpg": "36d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5754";